var noResult = document.querySelector('#search-no-results-text');
 if (window.location.search.indexOf('q_l') > -1 || window.location.search.indexOf('q_w') > -1 || window.location.search.indexOf('q_h') > -1) {
   noResult = document.querySelector('#search-no-results-dimensions');
 }

if (noResult) {
  noResult = JSON.parse(noResult.innerHTML);
}


// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    showLimitList: '24,36,48',
    numberFilterTree: 2,
    showPlaceholderProductList: true,
    placeholderProductPerRow: 4
  },
  template: {
    skeletonProduct: '<li class="productgrid--item imagestyle--medium productitem--emphasis bc-sf-filter-product-skeleton">' +
      '<article class="productitem">' +
      '<div class="bc-sf-filter-skeleton-image" style="padding-top: 95%"></div>' +
      '<div class="productitem--info bc-sf-filter-skeleton-meta">' +
      '<span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton"></span>' +
      '<span class="bc-sf-filter-skeleton-text bc-sf-filter-skeleton-width1"></span>' +
      '</div>' +
      '</article>' +
      '</li>',
    noResult: noResult
  }
};

// Declare Templates

var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml':  '<li class="{{customClass}}" data-product-item>' +
                                '{{itemJson}}' +
                                '<article id="{{itemHandle}}" class="productitem" data-product-item-content>' +
                                    '<a class="productitem--image-link" href="{{itemUrl}}">' +
                                        '<figure class="productitem--image" data-product-item-image>' +
                                            '{{itemImages}}' +
                                            '{{itemLabels}}' +
                                        '</figure>' +
                                    '</a>' +
                                    '<div class="productitem--info">' +
                                        '{{emphasizePrice}}'  +
                                        '<h2 class="productitem--title">' +
                                            '<a href="{{itemUrl}}" data-product-page-link>' +
                                                '{{itemTitle}}' +
                                            '</a>' +
                                        '</h2>' +
                                        '<div class="productitem--dimensions">' +
                                          '{{itemDimensions}}' +
                                        '</div>' +
                                        '{{noEmphasizePrice}}'  +
                                        '<div class="productitem--row">' +
                                          '{{itemColourCount}}' +
                                          '{{itemReviews}}' +
                                        '</div>' +
                                        '<a href="{{itemUrl}}" class="productitem--action-atc productitem--btn button-primary" {{itemDisabled}}>' +
                                          '{{itemChooseColour}}' +
                                        '</a>' +
                                        '{{stockMessage}}' +
                                        '{{itemDescription}}' +
                                    '</div>' +
                                '</article>' +
                            '</li>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination--previous"><a class="pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span>' + bcSfFilterConfig.label.prev + '</a></li>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<li class="pagination--next"><a class="pagination--item" href="{{itemUrl}}">' + bcSfFilterConfig.label.next + '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span></a></li>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li><a class="pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
    'paginateHtml': '<div class="pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',

    // Sorting Template
    'sortingHtml':  '<label class="utils-sortby-title" for="product_grid_sort">' + bcSfFilterConfig.label.sorting + '</label>' +
                    '<div class="utils-sortby-select form-field-select-wrapper no-label">' +
                        '<select class="form-field form-field-select">{{sortingItems}}</select>' +
                        '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg>' +
                    '</div>',

    // Show limit Template
    'showLimitHtml': '<li><span class="utils-showby-title">' + bcSfFilterConfig.label.show_per_page + '</span></li>{{showLimitItems}}',
};

/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
  var self = this;
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var productTags = data.tags; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }

  var discountPercentage = 0;
  if (typeof window.customer_tags !== 'undefined' && window.customer_tags !== '' && window.customer_tags !== null) {
    var discount_tag = window.customer_tags.find(function (tag, index) {
      return tag.substring('customer:trade') !== -1;
    })

    if(discount_tag) {
      discountPercentage = parseInt(discount_tag.split('customer:trade')[1]);
    }
  }


  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  var productTags = data.tags;

  var product_grid_show_second_image = bcSfFilterConfig.custom.product_grid_show_second_image;
  var emphasize_price = bcSfFilterConfig.custom.emphasize_price;
  var enable_quick_shop = bcSfFilterConfig.custom.enable_quick_look;
  var enable_quick_buy = bcSfFilterConfig.custom.enable_quick_buy;
  var priority_colours = bcSfFilterConfig.custom.priority_colours;

  // Add custom class
  var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
  if (onSale) customClass += ' productitem--sale';
  if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
  itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

  let priorityVariants = [];
  if (priority_colours) {
    priorityVariants = data.variants.filter(variant => {
      let r = false;
      variant.options.forEach(option => {
        if (priority_colours.includes(option.toLowerCase())) {
          r = true;
        }
      })
      return r;
    });
  }

  let image = images[0];
  if (priorityVariants.length > 0) {
    // Get a random priority variant.
    const priorityVariant = priorityVariants[Math.floor(Math.random() * priorityVariants.length)];

    // Find the matching image in the images array
    if (priorityVariant && priorityVariant.image) {
      image = images.filter(image => image.src === priorityVariant.image)[0];
    }
  }

  var itemImages = '';
  var lengthImages = images.length;
  if (lengthImages > 0) {
    if (lengthImages > 1 && bcSfFilterConfig.custom.product_grid_show_second_image) {
      itemImages += buildItemImage(images[1], '384x', 'productitem--image-alternate', data);
    }
    itemImages += buildItemImage(image, '384x', 'productitem--image-primary', data);
  } else {
    itemImages += '<img alt="{{itemTitle}}" src="' + bcSfFilterConfig.custom.placeholder_svg_tag + '">';
  }
  itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '384x') : bcSfFilterConfig.custom.placeholder_svg_tag;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Label
  var itemLabelsHtml = '';
  var itemDisabled = '';
  if (soldOut) {
    itemLabelsHtml += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out + '</span>';
    itemDisabled = 'disabled';
  } else if (!soldOut) {
    var checkTag = false;
    jQ.each(productTags, function(i, v) {
      if (v.toLowerCase() != "pre order") {
        var checkTag = true;

        return false;
      }

    });
    if (checkTag == true) {
      //         itemLabelsHtml += '<span class="productitem--badge badge--instock for-preorder"></span>';
    } else {
      var inStockCheck = true;
      var anotherTagCheck = "";
      jQ.each(productTags, function(i, value) {
        // console.log(value);
        if (value == "hide-instock-badge" || value.toLowerCase() == "pre order") {
          inStockCheck = false;
          return false;
        }
        if (value == "oversize") {
          anotherTagCheck = "oversize";
        }
        if (value == "dangerous-goods") {
          anotherTagCheck = "dangerous-goods";
        }

      });
      if (inStockCheck) {
        itemLabelsHtml += '<span class="productitem--badge badge--instock "></span>';
      }
      if (anotherTagCheck != "") {
        itemLabelsHtml += '<span class="productitem--badge badge-css badge--' + anotherTagCheck + '"></span>';
      }
    }
  }

  // else {
  if (onSale && bcSfFilterConfig.custom.product_sales_badge || window.sawCartDiscount) {
    var savePrice = data.compare_at_price_min - data.price_min;
    var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_max);
    var percentTrade = discountPercentage;
    var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
    if(window.sawCartDiscount != undefined) {
      var percentSavePriceHtml = '<span data-price-percent-saved>' + percentTrade + '</span>';
    } else if(Number.isInteger(discountPercentage)) {
      var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
    }
    itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
    switch (bcSfFilterConfig.custom.product_sales_badge_style) {
      case 'percentile':
        itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml);
        break;
      case 'money':
        itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice));
        break;
      default:
        itemLabelsHtml += bcSfFilterConfig.label.sale;
        break;
    }
    itemLabelsHtml += '</span>';
  }

  if (productTags.includes('icon:reversible')) {
    itemLabelsHtml += getLabel('icon:reversible');
  }

  if (productTags.includes('icon:new-lower-price')) {
    itemLabelsHtml += getLabel('icon:new-lower-price');
  }

  itemHtml = itemHtml.replace(/{{itemDisabled}}/g, itemDisabled);
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

  // Add vendor
  var itemVendorHtml = '';
  if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '') {
    itemVendorHtml += '<h3 class="productitem--vendor">' + data.vendor + '</h3>';
  }
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

  // Add review rating
  var itemReviewsHtml = '';
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    itemReviewsHtml += '<div class="productitem--ratings">' +
      '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
      '<span class="spr-badge">' +
      '<span class="spr-starrating spr-badge-starrating">' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '<i class="spr-icon spr-icon-star-empty"></i>' +
      '</span>' +
      '</span>' +
      '</span>' +
      '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);


  // Add quickBtn
  // var quickBtnHtml = '';
  // var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
  // var show_modal = bcSfFilterConfig.custom.show_modal;
  // if (bcSfFilterConfig.custom.enable_quick_look == true || bcSfFilterConfig.custom.enable_quick_buy == true) {
  //   var quick_look_text = bcSfFilterConfig.label.quick_look_text;
  //   var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
  //   var quick_look_classes = 'productitem--action-trigger button-secondary';
  //   var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
  //   if (has_variants) {
  //     quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
  //     show_modal = true;
  //   }
  //   if (!data.available) {
  //     quick_buy_text = bcSfFilterConfig.label.sold_out;
  //     quick_buy_classes = quick_buy_classes + ' disabled';
  //   }
  //   quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
  //   quickBtnHtml += '<div class="productitem--listview-price">' +
  //     '{{emphasizePrice}}' +
  //     '</div>' +
  //     '<div class="productitem--listview-badge"></div>';

  //   if (bcSfFilterConfig.custom.enable_quick_buy) {
  //     if (!has_variants) {
  //       var temp = ' data-quick-buy ';
  //     } else {
  //       var temp = ' data-quickshop-slim ';
  //     }
  //     //console.log(data.id);
  //     if (data.tags.indexOf('Pre order') !== -1) {
  //       quickBtnHtml += '<form method="post" action="/cart/add" id="product_form_' + data.id + '" accept-charset="UTF-8" class="" enctype="multipart/form-data" data-product-form="">';
  //       quickBtnHtml += '<input type="hidden" id="preorder-note" name="properties[PN-Note]" value="Pre-order Item">';
  //       quickBtnHtml += '<input name="id" value="' + data.variants[0].id + '" type="hidden">';
  //       quickBtnHtml += '<div class="productitem--action">';
  //       quickBtnHtml += ' <button class="product-form--atc-button sbb col-pre-order data-variant-id="' + data.variants[0].id + '" type="submit" data-product-atc="" value="Preorder Now">';
  //       quickBtnHtml += '<span class="atc-button--text quick-but">Preorder Now</span>';
  //       quickBtnHtml += '<span class="atc-button--icon">';
  //       quickBtnHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>';
  //       quickBtnHtml += '</span>';
  //       quickBtnHtml += '</button>';
  //       quickBtnHtml += '</div>';
  //       quickBtnHtml += '</form>';

  //     } else {

  //       quickBtnHtml += '<div class="productitem--action">' +
  //         '<button class="' + quick_buy_classes + '" tabindex="1" type="button" aria-label="' + quick_buy_text + '"' +
  //         temp + 'data-variant-id="' + data.variants[0].id + '"';
  //       if (!data.available) {
  //         quickBtnHtml += ' disabled';
  //       }
  //       quickBtnHtml += '>';
  //       quickBtnHtml += '<span class="atc-button--text quick-but">' + quick_buy_text + '</span>';
  //       quickBtnHtml += '<span class="atc-button--icon">';
  //       quickBtnHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/> </g> </svg>';
  //       quickBtnHtml += '</span>';
  //       quickBtnHtml += '</button>';
  //       quickBtnHtml += '</div>';
  //     }

  //   }

  //   if (bcSfFilterConfig.custom.enable_quick_look) {
  //     quickBtnHtml += '<div class="productitem--action">' +
  //       '<button class="' + quick_look_classes + '" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' + quick_look_text +
  //       '</button>' +
  //       '</div>';
  //   }

  //   quickBtnHtml += '</div>';
  // }
  // itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);
  //
  //
  var itemColourCount = 0;
  var itemColourCountHtml = '';
  var packsizeTag = '';
  var hasPackSize = false;
  var packsize = 1;
  var itemChooseColour = '';

  for(var i in productTags){
    var tag = productTags[i];
    // console.log('tag', tag);
    if(tag.indexOf('colour:') != -1){
      itemColourCount = itemColourCount + 1;
    }
    if(hasPackSize == false && tag.indexOf('pack-size:') != -1){
      hasPackSize = true;
      packsizeTag = tag;
    }
  }
  if(itemColourCount < 2){
    itemChooseColour = 'View Product';
  } else {
    itemChooseColour = 'Choose Colour';
    if(itemColourCount > 10) {
      itemColourCountHtml = '<div class="productitem--colours">' + '10+' + ' Colours Available</div>';
    } else {
      itemColourCountHtml = '<div class="productitem--colours">' + itemColourCount + ' Colours Available</div>';
    }
  }

  itemHtml = itemHtml.replace(/{{itemColourCount}}/g, itemColourCountHtml);
  itemHtml = itemHtml.replace(/{{itemChooseColour}}/g, itemChooseColour);

  if(packsizeTag != ''){
    packsize = parseInt(packsizeTag.replace('pack-size:','').trim());
  }
  itemHtml = itemHtml.replace(/{{itemPackSize}}/g, packsize);

  var tradeDiscount = data.price_min / 100 * discountPercentage;

  // Add Price
  var priceHtml = '';
  var classVaries = priceVaries ? 'price--varies' : '';
  var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
  priceHtml += '<div class="productitem--price ' + classVaries + '">';
  priceHtml += '<div class="price--product-item">';
  if (!productTags.includes('pack-size:1')) {
    priceHtml += '<div class="price--product-item__heading">';
  }
  if(data.price_max > data.price_min) {
    priceHtml += 'From ';
  }
  if (!productTags.includes('pack-size:1')) {
    priceHtml += '<strong>';
    if(discountPercentage) {
      priceHtml += this.formatMoney((data.price_min - tradeDiscount) / packsize);
    } else {
      priceHtml += this.formatMoney(data.price_min / packsize);
    }
    priceHtml += '</strong> p/unit ex VAT</div>';
  }
  priceHtml += '<div class="price--product-item__heading">';
  if (data.price_max > data.price_min) {
    priceHtml += 'From ';
  }
  if (discountPercentage) {
    priceHtml += this.formatMoney(data.price_min - tradeDiscount);
  } else {
    priceHtml += this.formatMoney(data.price_min);
  }
  priceHtml += ' p/pack ex VAT</div>';

  priceHtml += '</div>';
  priceHtml += '</div>';
  
  // Add emphasize price
  var emphasizePriceHtml = '';
  var noEmphasizePriceHtml = '';
  if (bcSfFilterConfig.custom.emphasize_price) {
    emphasizePriceHtml += priceHtml;
  } else {
    noEmphasizePriceHtml += priceHtml;
  }
  itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
  itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

  itemHtml = itemHtml.replace(/{{itemJson}}/g, '<script type="application/json" data-product-data>' + JSON.stringify(data) + '</script>');

  var lengthMm = '';
  var widthMm = '';
  var heightMm = '';
  var prefixLength = 'length:';
  var prefixWidth = 'width:';
  var prefixHeight = 'height:';
  productTags.map(function(tag){
    if(tag.indexOf(prefixLength) != -1) {
      lengthMm = 'L: ' + tag.replace(prefixLength,'').replace('mm','');
    }
    if(tag.indexOf(prefixWidth) != -1) {
      widthMm = 'W: ' + tag.replace(prefixWidth,'').replace('mm','');
    }
    if(tag.indexOf(prefixHeight) != -1) {
      heightMm = 'H: ' + tag.replace(prefixHeight,'').replace('mm','');
    }
  });

  var dimensionsString = '';
    if (lengthMm.length > 1 || widthMm.length > 1 || heightMm.length > 1) {
      let dimensionsInMm = [lengthMm, widthMm, heightMm];
      dimensionsString = '<p>(mm) ';
      dimensionsString += dimensionsInMm.filter(function(string) {
        return string !== ''
      }).join(' x ') + '</br>';

      let dimensionsInInches = dimensionsInMm.map(function(dimension) {
        let dimensionValues = dimension.split(' ');
        // Convert mm to inches, 25.4 is the factor by which to divide mm to get inches
        if (dimensionValues[1]) {
          let textValidation = /[a-zA-Z]/g;

          if (textValidation.test(dimensionValues[1])) {
            return dimensionValues[0] + ' ' + dimensionValues[1];
          }

          dimension = Number(dimensionValues[1].trim()) / 25.4;

          return dimensionValues[0] + ' ' + dimension.toFixed(1);
        } else {
          return '';
        }
      });
      dimensionsString += '(in) ' + dimensionsInInches.filter(function(string) {
        return string !== ''
      }).join(' x ') + '</p>'
}
  itemHtml = itemHtml.replace(/{{itemDimensions}}/g, dimensionsString);
  itemHtml = itemHtml.replace(/{{stockMessage}}/g, getLabel('in-stock'));

  // Add description
  var itemDescriptionHtml = '';
  if (data.description && data.description.length > 0) {
    itemDescriptionHtml += '<div class="productitem--description">' +
      '<p>' + bcsffilter.truncateByChar(data.description, 150) + '</p>';
    if (data.description.length > 150) {
      itemDescriptionHtml += '<a href="{{itemUrl}}" class="productitem--link">' + bcSfFilterConfig.label.view_details + '</a>';
    }
    itemDescriptionHtml += '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  var itemUrlHtml = this.buildProductItemUrl(data);
  var selectedColor = displayColour;

  if (self.queryParams.hasOwnProperty('pf_t_colour') && self.queryParams.pf_t_colour.length == 1) {
     selectedColor = self.queryParams.pf_t_colour[0];
  }
  
  var matchVariant = getMatchedVariant(data, selectedColor);
  if (matchVariant && matchVariant.length > 0) {
    var isBoxBuilder = data.product_type === 'Box Builder';

    if (isBoxBuilder && !! matchVariant[0].image) {
      itemUrlHtml += '?lid=' + matchVariant[0]['title'].replaceAll(' ', '_') +
                     '&base=' + matchVariant[0]['title'].replaceAll(' ', '_');
    } else if (matchVariant[0].id) {
      itemUrlHtml += '?variant=' + matchVariant[0].id;
    }
  }

  itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemUrlHtml);

  return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }

  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;

    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);

    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }

    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

    jQ(this.selector.pagination).html(paginationHtml);
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');

    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        if (arr[k] == this.queryParams.limit) {
          showLimitItemsHtml += '<li><a class="utils-showby-item active" href="' + arr[k] + '">' + arr[k] + '</a></li>';
        } else {
          showLimitItemsHtml += '<li><a class="utils-showby-item" href="' + arr[k] + '">' + arr[k] + '</a></li>';
        }
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
    }
  }
};

BCSfFilter.prototype.buildShowLimitEvent = function() {
  var _this = this;
  jQ(this.selector.topShowLimit + ' li a').click(function(e) {
    onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).attr('href'));
  })
};

/************************** END BUILD TOOLBAR **************************/

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
    var colInfo = colData.collection;
    var delimiter = '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
    var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> ';
    breadcrumbHtml += delimiter;
    breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
    jQ('.breadcrumbs-container').html(breadcrumbHtml);
  }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span class="utils-viewtoggle-label">' + bcSfFilterConfig.label.view_as_title + ' </span>';
  itemHtml += '<button class="active bc-sf-filter-display-grid" data-display-type="' + this.buildToolbarLink('display', 'list', 'grid') + '">';
  itemHtml += '<svg class="icon-grid " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">          <title>Grid icon</title>        <rect x="4" y="4" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>      <rect x="12" y="4" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>      <rect x="4" y="12" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>      <rect x="12" y="12" width="4" height="4" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></rect>    </svg>';
  itemHtml == '</button>';
  itemHtml += '<button class="bc-sf-filter-display-list" data-display-type= "' + this.buildToolbarLink('display', 'grid', 'list') + '">';
  itemHtml += '<svg class="icon-list " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">          <title>List icon</title>        <path d="M4 4.75H16" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></path>      <path d="M4 15.25H16" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></path>      <path d="M4 10H16" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round"></path>    </svg>';
  itemHtml == '</button>';

  jQ(this.selector.topDisplayType).html(itemHtml);

  // Active current display type
  jQ(this.selector.topDisplayType).find('button').removeClass('active');
  if (this.queryParams.display == 'list') {
    jQ(this.selector.topDisplayType).find('button.bc-sf-filter-display-list').addClass('active');
  } else if (this.queryParams.display == 'grid') {
    jQ(this.selector.topDisplayType).find('button.bc-sf-filter-display-grid').addClass('active');
  }
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  jQ(this.selector.topDisplayType + ' button').unbind('click');
  jQ(this.selector.topDisplayType + ' button').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children('button').removeClass('active');
    jQ(this).addClass('active');
    var newUrl = jQ(this).attr('data-display-type');
    if (newUrl.indexOf('list') != -1) {
      jQ('.productgrid--outer').addClass('productgrid-listview');
      jQ('.productgrid--outer').removeClass('productgrid-gridview');
    } else {
      jQ('.productgrid--outer').removeClass('productgrid-listview');
      jQ('.productgrid--outer').addClass('productgrid-gridview');
    }
    _this.onChangeData(newUrl, 'display');
  })
};


// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  var self = this;
  // Integrate Product Reviews
  if (bcSfFilterConfig.custom.product_ratings_reviews) {
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }
  }

  var sections = bcSfFilterSections;
  if (!self.isSearchPage()) {
    sections.register('static-collection', function(section) {
      return new bcSfFilterStaticCollection(section);
    });
  } else {
    //console.log('Search page');
    sections.register('static-search', function(section) {
      return new bcSfFilterStaticSearch(section);
    });
  }

  if (typeof bcSfFilterRImg !== 'undefined') {
    bcSfFilterRImg.init('[data-rimg="lazy"]', { round: 1 });
  }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  if (this.queryParams.display == 'list') {
    jQ('.productgrid--outer').addClass('productgrid-listview');
    jQ('.productgrid--outer').removeClass('productgrid-gridview');
  } else {
    jQ('.productgrid--outer').removeClass('productgrid-listview');
    jQ('.productgrid--outer').addClass('productgrid-gridview');
  }
  //jQ('#bc-sf-filter-products').css('display', 'flex');
  //    jQ('.product-recently-viewed-wrapper').find('.productitem--actions').remove();
  //  jQ('.results--container').addClass('bc--container');
  //    jQ('.bc--container').removeClass('results--container');
  // Build Breadcrumb of Search page
  if (this.isSearchPage()) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm != null) {
      content = bcSfFilterConfig.label.search_breadcrumbs_count_other;
      if (data.total_product == 1) {
        content = bcSfFilterConfig.label.search_breadcrumbs_count_one;
      } else if (data.total_product == 0) {
        content = bcSfFilterConfig.label.search_breadcrumbs_count_zero;
      }
      content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
      content = content.replace(/&lt;strong&gt;/g, '<strong>').replace(/&lt;\/strong&gt;/g, '</strong>');
    }
    jQ('.breadcrumbs-container span:last-child').html(content);
    jQ('.breadcrumbs-container span').css('display', 'inline-block');
  }

};

function buildItemImage(image, size, className, data) {
  var self = bcsffilter;
  var itemThumbUrl = typeof image.src !== 'undefined' ? image.src : bcSfFilterConfig.general.no_image_url;
  var selectedColor = displayColour;
  if (self.queryParams.hasOwnProperty('pf_t_colour') && self.queryParams.pf_t_colour.length == 1) {
    selectedColor = self.queryParams.pf_t_colour[0];
  }
  var matchVariant = getMatchedVariant(data, selectedColor);
  if (matchVariant && matchVariant.length > 0) {
    if (typeof matchVariant[0] !== 'undefined' && typeof matchVariant[0]['image'] !== 'undefined' && matchVariant[0]['image'] !== null) {
      itemThumbUrl = matchVariant[0]['image'];
    }
  }

  var size = typeof size !== 'undefined' ? size : 'large';
  var className = typeof className !== 'undefined' ? className : '';

  var html = '';

  html += '<noscript data-rimg-noscript>';
  html += '<img class="' + className + '" ';
  html += ' src="' + bcsffilter.optimizeImage(itemThumbUrl, size) + '"';
  html += ' alt="{{itemTitle}}"';
  html += ' data-rimg="noscript"';
  html += ' srcset="' + bcsffilter.optimizeImage(itemThumbUrl, size) + ' 1x"'
  html += '>';
  html += '</noscript>';

  html += '<img class="' + className + '" ';
  html += ' src="' + bcsffilter.optimizeImage(itemThumbUrl, size) + '"';
  html += ' alt="{{itemTitle}}"';
  html += ' data-rimg="lazy"';
  html += ' data-rimg-scale="1"';
  html += ' data-rimg-template="' + bcsffilter.optimizeImage(itemThumbUrl, '{size}') + '"';
  html += ' data-rimg-max="' + image.width + 'x' + image.height + '"';
  html += ' data-rimg-crop';
  html += ' srcset="' + bcsffilter.optimizeImage(itemThumbUrl, size) + ' 1x"'
  html += '>';

  html += '<div data-rimg-canvas></div>';

  return html;
}

// Get the product variant that matches the selected colour
function getMatchedVariant(data, selectedColor) {
  // Update so it works with "Color" or "Colour"
  var selected_color_lower = selectedColor.toLowerCase().replace('colour', 'color');
  var options = data.options_with_values.filter(function(e) {
    return (e.name).toLowerCase() == 'color' || (e.name).toLowerCase() == 'colour';
  });
  if (typeof options[0] !== 'undefined') {
    // Set Url with variant
    var matchVariant = data.variants.filter(function(e) {
      for (var i = 0; i < e.merged_options.length; i++) {
        var merged_option_color_lower = e.merged_options[i].toLowerCase().replace('colour', 'color');
        if (merged_option_color_lower.indexOf(selected_color_lower) !== -1) {
          return true;
        }
      }
    });

    return matchVariant;
  }
}


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

function getLabel(labelName) {
  switch (labelName) {
    case 'icon:reversible':
      return '<span class="product-label product-label-reversible">Reversible</span>';
    case 'in-stock':
      return '<div class="despatch-info">' +
        '<svg class="instock-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 161 180">\n' +
        '    <defs>\n' +
        '        <clipPath id="clip-Svg_Icon">\n' +
        '            <rect width="161" height="180"/>\n' +
        '        </clipPath>\n' +
        '    </defs>\n' +
        '    <g id="Svg_Icon" data-name="Svg Icon" clip-path="url(#clip-Svg_Icon)">\n' +
        '        <g id="Group_6" data-name="Group 6" transform="translate(-483.401 -266.25)">\n' +
        '            <path id="Path_1" data-name="Path 1"\n' +
        '                  d="M625.64,317.14l-57.476-33a8.382,8.382,0,0,0-7.527,0l-57.47,33a8.29,8.29,0,0,0-3.767,6.482V389.63a8.3,8.3,0,0,0,3.767,6.482l57.47,33a8.382,8.382,0,0,0,7.527,0l57.476-33a8.292,8.292,0,0,0,3.761-6.482V323.622a8.283,8.283,0,0,0-3.761-6.482"\n' +
        '                  transform="translate(0 0)" fill="#18964e"/>\n' +
        '            <g id="Group_1" data-name="Group 1" transform="translate(520.702 328.791)">\n' +
        '                <path id="Path_2" data-name="Path 2"\n' +
        '                      d="M537.6,355.891l-34.509-34.512,8.892-8.892L537.6,338.1l46.97-46.971,8.892,8.892Z"\n' +
        '                      transform="translate(-503.088 -291.133)" fill="#fff"/>\n' +
        '            </g>\n' +
        '        </g>\n' +
        '    </g>\n' +
        '</svg>' +
        '<span class="despatch-message">NEXT DAY UK SHIPPING</span>' +
        '</div>';
    case 'icon:new-lower-price':
      return '<span class="product-label product-label-new-lower-price">New price</span>';
    default:
      return '';
  }
}
